// ==========================================================================
// HALFBAG THEME INTERACTIVE JS & SMART CART ENGINE
// ==========================================================================

document.addEventListener('DOMContentLoaded', () => {
  initThumbnails();
  initHeroSliders();
  initAccordions();
  initStickyBuyBar();
  initAjaxCart();
  initDrawerEvents();
  // Pre-load initial cart state
  refreshCartDrawer(false);
});

// 1. Thumbnail image switcher
function initThumbnails() {
  const mainImg = document.getElementById('MainProductImage');
  const thumbs = document.querySelectorAll('.thumb-btn');
  if (!mainImg || thumbs.length === 0) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const newSrc = thumb.getAttribute('data-full-src');
      if (newSrc) {
        mainImg.style.opacity = '0.4';
        setTimeout(() => {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        }, 150);
      }
    });
  });
}

// 2. Accordions (Vil du vite mer?)
function initAccordions() {
  const headers = document.querySelectorAll('.accordion-header');
  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      if (!item) return;
      const isActive = item.classList.contains('active');
      // Close all other items
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });
}

// 3. Sticky Bottom Buy Bar
function initStickyBuyBar() {
  const buyBar = document.getElementById('StickyBuyBar');
  const mainBuyBtn = document.querySelector('.btn-add-to-cart');
  if (!buyBar || !mainBuyBtn) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        buyBar.classList.remove('visible');
      } else {
        buyBar.classList.add('visible');
      }
    });
  }, { threshold: 0.1 });

  observer.observe(mainBuyBtn);
}

// 4. AJAX Cart functionality (Interception of all add to cart forms)
function initAjaxCart() {
  const forms = document.querySelectorAll('form[action$="/cart/add"]');
  forms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('.btn-add-to-cart') || form.querySelector('button[type="submit"]');

      // Guard: ignore clicks while a request for this form is already running
      if (form.dataset.hbBusy === '1') return;
      form.dataset.hbBusy = '1';

      const oldText = btn ? btn.innerText : '';
      if (btn) {
        btn.disabled = true;
        btn.innerText = 'Legger til...';
      }

      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (!res.ok) throw new Error('Kunne ikke legge til i kurv');
        if (btn) btn.innerText = 'Lagt til! ✓';
        await refreshCartDrawer(true);
      } catch (err) {
        console.error('Add to cart error:', err);
        alert('Kunne ikke legge varen i handlekurven. Vennligst prøv igjen.');
      } finally {
        setTimeout(() => {
          form.dataset.hbBusy = '0';
          if (btn) {
            btn.disabled = false;
            btn.innerText = oldText;
          }
        }, 1800);
      }
    });
  });
}

// 5. Drawer overlay and keyboard events
function initDrawerEvents() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) {
        closeCartDrawer();
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer();
    }
  });
}

// 6A. Shared HTML builder for cart items (used by drawer AND cart page)
function hbCartItemsHtml(cart) {
  let html = '<div class="cart-items-list">';
  cart.items.forEach(item => {
    const linePrice = Math.round(item.line_price / 100).toLocaleString('nb-NO') + ' kr';
    const variantText = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    const itemImg = item.image || item.featured_image?.url || '';
    html += `
      <div class="cart-drawer-item" data-key="${item.key}">
        ${itemImg ? `<img src="${itemImg}" alt="${item.product_title || item.title}" class="cart-drawer-item-img" />` : ''}
        <div class="cart-drawer-item-details">
          <div class="cart-drawer-item-header">
            <h4 class="cart-drawer-item-title">${item.product_title || item.title}</h4>
            <button type="button" class="cart-drawer-item-remove" onclick="changeCartItem('${item.key}', 0)" title="Fjern vare">&times;</button>
          </div>
          ${variantText ? `<div class="cart-drawer-item-variant">${variantText}</div>` : ''}
          <div class="cart-drawer-item-bottom">
            <div class="cart-drawer-qty-stepper">
              <button type="button" class="qty-btn" onclick="changeCartItem('${item.key}', ${item.quantity - 1})" aria-label="Reduser antall">&minus;</button>
              <span class="qty-val">${item.quantity}</span>
              <button type="button" class="qty-btn" onclick="changeCartItem('${item.key}', ${item.quantity + 1})" aria-label="Øk antall">&plus;</button>
            </div>
            <div class="cart-drawer-item-price">${linePrice}</div>
          </div>
        </div>
      </div>`;
  });
  return html + '</div>';
}

// 6. Refresh Cart Drawer + Cart Page
async function refreshCartDrawer(openAfterRefresh = false) {
  try {
    const res = await fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' });
    const cart = await res.json();

    // Update count bubbles
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.innerText = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });

    const countBadge = document.getElementById('CartDrawerCountBadge');
    if (countBadge) {
      countBadge.innerText = cart.item_count;
    }

    const subtotalEl = document.getElementById('CartDrawerSubtotalAmount');
    if (subtotalEl) {
      subtotalEl.innerText = Math.round(cart.total_price / 100).toLocaleString('nb-NO') + ' kr';
    }
    const cartPageTotal = document.getElementById('CartPageTotalAmount');
    if (cartPageTotal) {
      cartPageTotal.innerText = Math.round(cart.total_price / 100).toLocaleString('nb-NO') + ' kr';
    }

    // ---- CART PAGE: re-render item list + upsell ----
    const pageItems = document.getElementById('CartPageItems');
    if (pageItems) {
      if (cart.items.length === 0) { window.location.reload(); return; }
      pageItems.innerHTML = hbCartItemsHtml(cart);
    }
    const pageUpsell = document.getElementById('hb-smart-upsell-container-page');
    if (pageUpsell) hbRenderCartOffers(pageUpsell, cart);

    const itemsContainer = document.getElementById('CartDrawerItems');
    const itemsWrapper = document.getElementById('CartDrawerItemsWrapper');
    const upsellContainer = document.getElementById('hb-smart-upsell-container');
    const footer = document.getElementById('CartDrawerFooter');

    // 6A. Render In-Cart Items Box (drawer)
    if (itemsContainer) {
      if (cart.items.length === 0) {
        itemsContainer.innerHTML = '<p class="empty-cart-msg" style="padding: 1.6rem 0; text-align: center; color: #666; font-size: 1.4rem;">Handlekurven din er tom.</p>';
        if (itemsWrapper) {
          itemsWrapper.style.border = 'none';
          itemsWrapper.style.background = 'transparent';
          itemsWrapper.style.padding = '0';
          const header = itemsWrapper.querySelector('.hb-cart-header');
          if (header) header.style.display = 'none';
        }
        if (upsellContainer) upsellContainer.innerHTML = '';
        if (footer) {
          const checkoutBtn = footer.querySelector('.cart-drawer-checkout-btn');
          if (checkoutBtn) checkoutBtn.style.display = 'none';
        }
        return;
      } else {
        if (itemsWrapper) {
          itemsWrapper.style.border = '';
          itemsWrapper.style.background = '';
          itemsWrapper.style.padding = '';
          const header = itemsWrapper.querySelector('.hb-cart-header');
          if (header) header.style.display = 'flex';
        }
        if (footer) {
          const checkoutBtn = footer.querySelector('.cart-drawer-checkout-btn');
          if (checkoutBtn) checkoutBtn.style.display = 'block';
        }

        itemsContainer.innerHTML = hbCartItemsHtml(cart);
      }
    }

    // 6B. Tilbehørstilbud over kasseknappen (drawer).
    // Innholdet styres fra Temainnstillinger → Handlekurv-tilbud. Ingen priser er hardkodet her.
    if (upsellContainer) {
      hbRenderCartOffers(upsellContainer, cart);
    }

    if (openAfterRefresh) {
      openCartDrawer();
    }
  } catch (err) {
    console.error('Error fetching cart:', err);
  }
}

// 7. Change line item quantity or remove (with busy guard)
async function changeCartItem(key, quantity) {
  if (window.__hbBusy) return;
  window.__hbBusy = true;
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    if (!res.ok) throw new Error('Change failed');
    await refreshCartDrawer(false);
  } catch (err) {
    console.error('Error changing cart item:', err);
  } finally {
    window.__hbBusy = false;
  }
}

// 7B. Tilbehørstilbud i handlekurven — datadrevet fra Temainnstillinger
function hbRenderCartOffers(container, cart) {
  const esc = (s) => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  const dataEl = document.getElementById('hb-cart-offers-data');
  if (!dataEl || !cart || !cart.items || cart.items.length === 0) { container.innerHTML = ''; return; }

  let cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { container.innerHTML = ''; return; }
  const offers = (cfg && cfg.offers) || [];
  if (!offers.length) { container.innerHTML = ''; return; }

  const inCart = cart.items.map((it) => String(it.handle || '').toLowerCase());

  const matches = offers.filter((o) => {
    if (!o || !o.available || !o.variant_id) return false;
    if (inCart.indexOf(String(o.handle).toLowerCase()) > -1) return false;
    const triggers = String(o.when || '').toLowerCase().split(',').map((s) => s.trim()).filter(Boolean);
    if (!triggers.length) return false;
    return inCart.some((h) => triggers.some((t) => h.indexOf(t) > -1));
  });

  if (!matches.length) { container.innerHTML = ''; return; }

  const cards = matches.map((o) => {
    const price = o.offer_price
      ? '<span class="hb-price-was">' + esc(o.price) + '</span> <strong class="hb-addon-now">' + esc(o.offer_price) + '</strong>'
      : '<strong class="hb-addon-now">' + esc(o.price) + '</strong>';
    const note = o.note ? ' <span class="hb-addon-note">' + esc(o.note) + '</span>' : '';
    const action = o.url
      ? '<a class="hb-btn-mini hb-addon-link" href="' + esc(o.url) + '">Se produktet</a>'
      : '<button type="button" class="hb-btn-mini" onclick="hbAddItemDirect(this, \'' + esc(o.variant_id) + '\', ' + (parseInt(o.qty, 10) || 1) + ')">+ Legg til</button>';
    return '<div class="hb-addon-item">' +
      (o.image ? '<img class="hb-addon-img" src="' + esc(o.image) + '" alt="" loading="lazy" />' : '') +
      '<div class="hb-addon-copy">' +
        '<div class="hb-addon-title">' + esc(o.title) + '</div>' +
        (o.text ? '<div class="hb-addon-desc">' + esc(o.text) + '</div>' : '') +
        '<div class="hb-addon-price">' + price + note + '</div>' +
      '</div>' +
      action +
    '</div>';
  }).join('');

  container.innerHTML = '<div class="hb-upsell-box">' +
    (cfg.title ? '<div class="hb-upsell-head">' + esc(cfg.title) + '</div>' : '') +
    cards + '</div>';
}

// 8. One-click direct add to cart for upsells
async function hbAddItemDirect(btn, variantId, qty) {
  if (btn) {
    btn.disabled = true;
    btn.innerText = 'Legger til...';
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty || 1 }]
      })
    });
    if (!res.ok) throw new Error('Add failed');
    if (btn) {
      btn.innerText = 'Lagt til! ✓';
      btn.style.backgroundColor = '#16a34a';
      btn.style.borderColor = '#16a34a';
      btn.style.color = '#ffffff';
    }
    setTimeout(async () => {
      await refreshCartDrawer(false);
    }, 250);
  } catch (err) {
    console.error('Error adding direct item:', err);
    if (btn) {
      btn.innerText = 'Prøv igjen';
      btn.disabled = false;
    }
  }
}

// 9. Add Halfsock Package with selected size
function hbAddHalfsockPackage(btn) {
  const sel = document.getElementById('hb-halfsock-select');
  const variantId = sel ? sel.value : '44037971968099';
  hbAddItemDirect(btn, variantId, 1);
}

// 10. Add Free Halfsock with selected size
function hbAddFreeHalfsock(btn) {
  const sel = document.getElementById('hb-free-sock-select');
  const variantId = sel ? sel.value : '44037971968099';
  hbAddItemDirect(btn, variantId, 1);
}

// 11. Toggle expandable bundle information
function hbToggleDetails(btn) {
  const info = document.getElementById('hb-bundle-details');
  if (!info) return;
  if (info.style.display === 'none' || !info.style.display) {
    info.style.display = 'block';
    btn.innerText = 'Vis mindre ▲';
  } else {
    info.style.display = 'none';
    btn.innerText = 'Les mer om pakken(e) ▼';
  }
}

// 12. Drawer open and close helpers
function openCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

// Global exposure for inline HTML event handlers
window.changeCartItem = changeCartItem;
window.hbAddItemDirect = hbAddItemDirect;
window.hbAddHalfsockPackage = hbAddHalfsockPackage;
window.hbAddFreeHalfsock = hbAddFreeHalfsock;
window.hbToggleDetails = hbToggleDetails;
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;
window.refreshCartDrawer = refreshCartDrawer;
window.hbUpdateSmartCart = refreshCartDrawer;


// Hero-bildekarusell på bruksområdesidene
function initHeroSliders() {
  document.querySelectorAll('.activity-hero-slider.has-many').forEach(function (slider) {
    var slides = slider.querySelectorAll('.activity-hero-slide');
    var dots = slider.querySelectorAll('.activity-hero-dot');
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;
    var seconds = parseInt(slider.getAttribute('data-autoplay'), 10) || 0;

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    function start() {
      if (seconds > 0) { stop(); timer = setInterval(function () { show(index + 1); }, seconds * 1000); }
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var prev = slider.querySelector('.activity-hero-nav.prev');
    var next = slider.querySelector('.activity-hero-nav.next');
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); start(); }); });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    start();
  });
}
